import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const ReportUrl = `${Base_Url}/Reports`;

export const GetJobReport = async (params) => {
  const res = await postApiWithAuthorization(
    `${ReportUrl}/GetJobReport`,
    params
  );
  return res;
};

export const GetAccountabilityReport = async (params) => {
  const res = await postApiWithAuthorization(
    `${ReportUrl}/GetAccountabilityReport`,
    params
  );
  return res;
};

export const GetTaskReport = async (params) => {
  const res = await postApiWithAuthorization(
    `${ReportUrl}/GetTaskReport`,
    params
  );
  return res;
};

export const GetClientFinancialReport = async (params) => {
  const res = await postApiWithAuthorization(
    `${ReportUrl}/GetClientFinancialReport`,
    params
  );
  return res;
};

export const GetClientLedgerReport = async (params) => {
  const res = await postApiWithAuthorization(
    `${ReportUrl}/GetClientLedgerReport`,
    params
  );
  return res;
};

export const GetProfitLossReport = async (params) => {
  const res = await postApiWithAuthorization(
    `${Base_Url}/Report/GetPnLReport`,
    params
  );
  return res;
};

export const GetClientPaymentReport = async (params) => {
  const res = await postApiWithAuthorization(
    `${ReportUrl}/GetClientPaymentReport`,
    params
  );
  return res;
};

export const GetAttendanceReport = async (params) => {
  const res = await postApiWithAuthorization(
    `${ReportUrl}/GetAttendanceReport`,
    params
  );
  return res;
};

export const GetKRAReport = async (params) => {
  const res = await postApiWithAuthorization(
    `${ReportUrl}/GetKRAReport`,
    params
  );
  return res;
};

export const GetProfitabilityReport = async (params) => {
  const res = await postApiWithAuthorization(
    `${ReportUrl}/GetProfitabilityReport`,
    params
  );
  return res;
};


export const GetProjectLeadgerData = async (params) => {

  const res = await postApiWithAuthorization(
    `${Base_Url}/ledger/GetProjectLedger?ProjectKeyID=${params.keyID}`,
    params
  );
  return res;
}

export const GetClientReportList = async (params) => {
  const res = await postApiWithAuthorization(
    `${Base_Url}/Parties/GetClientReportList`,
    params
  );
  return res;
}


export const GetTenderReportList = async (params) => {
  const res = await postApiWithAuthorization(
    `${Base_Url}/Parties/GetTenderReportList`,
    params
  );
  return res;
}


export const GetExpenseReportList = async (params) => {
  const res = await postApiWithAuthorization(
    `${Base_Url}/Expense/GetExpenseReportList`,
    params
  );
  return res;
}


export const GetAttendanceReportList = async (params) => {
  const res = await postApiWithAuthorization(`${Base_Url}/CheckInOut/GetAttendanceReportList`, params);
  return res;
};